<template>
  <span class="dashboard-icon-group">
    <el-tooltip content="정렬" placement="top">
      <el-dropdown ref="alignBtn" trigger="hover" @command="onAlignClick" placement="bottom" :show-timeout="100" :hide-timeout="100">
        <el-button class="btn-align" size="medium" type="content" :disabled="disabled"></el-button>
        <!-- <el-button size="medium" type="content" :disabled="disabled"><i class="fas fa-layer-group"></i></el-button> -->
        <el-dropdown-menu slot="dropdown">
          <el-tooltip content="맨 앞으로 가져오기" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_TO_TOP">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_frontmost']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_TO_TOP"><img src="@/assets/img/dashboard/button/align/send_to_top_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="맨 뒤로 보내기" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_TO_BOTTOM">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_backmost']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_TO_BOTTOM"><img src="@/assets/img/dashboard/button/align/send_to_bottom_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="앞으로 가져오기" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_FORWARD">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_front']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_FORWARD"><img src="@/assets/img/dashboard/button/align/send_forward_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="뒤로 보내기" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_BACKWARD">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_back']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.SEND_BACKWARD"><img src="@/assets/img/dashboard/button/align/send_backward_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="왼쪽 맞춤" placement="right">
            <el-dropdown-item divided :command="DashboardConst.WIDGET_ALIGN.LEFT">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_left']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item divided :command="DashboardConst.WIDGET_ALIGN.LEFT"><img src="@/assets/img/dashboard/button/align/align_left_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="가운데 맞춤" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.CENTER">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_center']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.CENTER"><img src="@/assets/img/dashboard/button/align/align_center_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="오른쪽 맞춤" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.RIGHT">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_right']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.RIGHT"><img src="@/assets/img/dashboard/button/align/align_right_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="위쪽 맞춤" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.TOP">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_top']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.TOP"><img src="@/assets/img/dashboard/button/align/align_top_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="중간 맞춤" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.MIDDLE">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_middle']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.MIDDLE"><img src="@/assets/img/dashboard/button/align/align_middle_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="아래쪽 맞춤" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.BOTTOM">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_bottom']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.BOTTOM"><img src="@/assets/img/dashboard/button/align/align_bottom_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="가로 간격을 동일하게" placement="right">
            <el-dropdown-item divided :command="DashboardConst.WIDGET_ALIGN.DISTRIBUTE_H">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_interval_column']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item divided :command="DashboardConst.WIDGET_ALIGN.DISTRIBUTE_H"><img src="@/assets/img/dashboard/button/align/distribute_horizontally_off.png" /></el-dropdown-item> -->
          </el-tooltip>
          <el-tooltip content="세로 간격을 동일하게" placement="right">
            <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.DISTRIBUTE_V">
              <div :class="['dashboard-align-tool', 'map-button', 'btn_interval_row']"></div>
            </el-dropdown-item>
            <!-- <el-dropdown-item :command="DashboardConst.WIDGET_ALIGN.DISTRIBUTE_V"><img src="@/assets/img/dashboard/button/align/distribute_vertically_off.png" /></el-dropdown-item> -->
          </el-tooltip>
        </el-dropdown-menu>
      </el-dropdown>
    </el-tooltip>
  </span>
</template>

<script>
import Vue from 'vue';

import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import cloneDeep from 'lodash/cloneDeep';

import Base from '@/mixins/dashboard/base';

import DashboardConst from '@/constants/dashboard';

import editHistory from '@/views/dashboard/js/edit-history';

export default {
  name: 'WWidgetAlignButton',
  mixins: [Base],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DashboardConst,
    };
  },
  watch: {
    disabled(val) {
      if (val === true) {
        this.$refs.alignBtn.hide();
      }
    },
  },
  methods: {
    onAlignClick(command) {
      editHistory.addEditHistory({
        type: DashboardConst.HISTORY_TYPE.ALIGN,
        elements: cloneDeep(this.alignTargetWidgets()),
      });

      const {
        SEND_TO_TOP,
        SEND_TO_BOTTOM,
        SEND_FORWARD,
        SEND_BACKWARD,
        LEFT,
        CENTER,
        RIGHT,
        TOP,
        MIDDLE,
        BOTTOM,
        DISTRIBUTE_H,
        DISTRIBUTE_V,
      } = DashboardConst.WIDGET_ALIGN;

      switch (command) {
        case SEND_TO_TOP:
          this.sendToTop();
          break;
        case SEND_TO_BOTTOM:
          this.sendToBottom();
          break;
        case SEND_FORWARD:
          this.sendForward();
          break;
        case SEND_BACKWARD:
          this.sendBackward();
          break;
        case LEFT:
          this.alignLeft();
          break;
        case CENTER:
          this.alignCenter();
          break;
        case RIGHT:
          this.alignRight();
          break;
        case TOP:
          this.alignTop();
          break;
        case MIDDLE:
          this.alignMiddle();
          break;
        case BOTTOM:
          this.alignBottom();
          break;
        case DISTRIBUTE_H:
          this.distributeHorizontally();
          break;
        case DISTRIBUTE_V:
          this.distributeVertically();
          break;
        default:
      }
    },
    sendToTop() {
      const widgets = this.alignTargetWidgets();

      let maxZIndex = Math.max.apply(null, this.widgetLayout.map((widget) => widget.z || 0));

      widgets.forEach((widget) => {
        Vue.set(widget, 'z', (maxZIndex += 1));
      });
    },
    sendToBottom() {
      const widgets = this.alignTargetWidgets();

      let minZIndex = Math.min.apply(null, this.widgetLayout.map((widget) => widget.z || 0));

      widgets.forEach((widget) => {
        Vue.set(widget, 'z', (minZIndex -= 1));
      });
    },
    sendForward() {
      const widgets = this.alignTargetWidgets();

      widgets.forEach((widget) => {
        Vue.set(widget, 'z', parseInt(widget.z, 10) + 1);
      });
    },
    sendBackward() {
      const widgets = this.alignTargetWidgets();

      widgets.forEach((widget) => {
        Vue.set(widget, 'z', parseInt(widget.z, 10) - 1);
      });
    },
    alignLeft() {
      const widgets = this.alignTargetWidgets();

      const left = Math.min.apply(null, widgets.map((widget) => (widget.x || 0)));

      widgets.forEach((widget) => {
        Vue.set(widget, 'x', left);
      });
    },
    alignCenter() {
      const widgets = this.alignTargetWidgets();

      const lx = Math.min.apply(null, widgets.map((widget) => (widget.x || 0)));
      const rx = Math.max.apply(null, widgets.map((widget) => (widget.x + widget.w || 0)));
      const cx = (lx + rx) / 2;

      widgets.forEach((widget) => {
        Vue.set(widget, 'x', cx - (widget.w / 2));
      });
    },
    alignRight() {
      const widgets = this.alignTargetWidgets();

      const right = Math.max.apply(null, widgets.map((widget) => (widget.x + widget.w || 0)));

      widgets.forEach((widget) => {
        Vue.set(widget, 'x', right - widget.w);
      });
    },
    alignTop() {
      const widgets = this.alignTargetWidgets();

      const top = Math.min.apply(null, widgets.map((widget) => (widget.y || 0)));

      widgets.forEach((widget) => {
        Vue.set(widget, 'y', top);
      });
    },
    alignMiddle() {
      const widgets = this.alignTargetWidgets();

      const ty = Math.min.apply(null, widgets.map((widget) => (widget.y || 0)));
      const by = Math.max.apply(null, widgets.map((widget) => (widget.y + widget.h) || 0));
      const my = (ty + by) / 2;

      widgets.forEach((widget) => {
        Vue.set(widget, 'y', my - (widget.h / 2));
      });
    },
    alignBottom() {
      const widgets = this.alignTargetWidgets();

      const bottom = Math.max.apply(null, widgets.map((widget) => (widget.y + widget.h) || 0));

      widgets.forEach((widget) => {
        Vue.set(widget, 'y', bottom - widget.h);
      });
    },
    distributeHorizontally() {
      const widgets = this.alignTargetWidgets();

      const lx = Math.min.apply(null, widgets.map((widget) => (widget.x || 0)));
      const rx = Math.max.apply(null, widgets.map((widget) => (widget.x + widget.w || 0)));
      const gap = ((rx - lx) - reduce(widgets, (total, widget) => total + widget.w, 0)) / (widgets.length - 1);

      widgets.sort((a, b) => a.x - b.x);

      let x = lx;
      widgets.forEach((widget, index) => {
        Vue.set(widget, 'x', x + (gap * index));
        x += widget.w;
      });
    },
    distributeVertically() {
      const widgets = this.alignTargetWidgets();

      const ty = Math.min.apply(null, widgets.map((widget) => (widget.y || 0)));
      const by = Math.max.apply(null, widgets.map((widget) => (widget.y + widget.h) || 0));
      const gap = ((by - ty) - reduce(widgets, (total, widget) => total + widget.h, 0)) / (widgets.length - 1);

      widgets.sort((a, b) => a.y - b.y);

      let y = ty;
      widgets.forEach((widget, index) => {
        Vue.set(widget, 'y', y + (gap * index));
        y += widget.h;
      });
    },
    alignTargetWidgets() {
      return filter(this.widgetLayout, ['active', true]);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/WidgetAlignButton.vue